export function CampermanIntegrationScreen() {
  return <div>{`That's it! We'll pull from the spreadsheet every hour`}</div>;
}
